module.exports = __webpack_public_path__ + "static/media/SoloStan.fb69a079.jpg";